<form [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title">{{ config.title }}</h5>
    <button (click)="close()" type="button" class="close">
      <i class="far fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <p [innerHtml]="config.help"></p>

        <app-select-search
          [inline]="false"
          bindValue="id"
          bindLabel="name"
          [items]="config.categories"
          [ctrl]="form.get('category')"
          [multiple]="false"
          placeholder="Select AdvanceCM rate category"
          i18n-placeholder
        >
          <ng-container class="error-container">
            <mat-error> <ng-container i18n>Category is required</ng-container> </mat-error>
          </ng-container>
        </app-select-search>

        <app-select-search
          bindLabel="name"
          [items]="channelRoomRates$ | async"
          [ctrl]="form.get('channelRate')"
          [multiple]="false"
          [inline]="false"
          [placeholder]="'Select ' + config.channelFriendlyName + ' rate category'"
        >
          <ng-container class="error-container">
            <mat-error> <ng-container i18n>Category is required</ng-container> </mat-error>
          </ng-container>
        </app-select-search>
        <section *ngIf="config.rental" class="rate-sample" aria-live="polite" [attr.aria-busy]="sampleLoading">
          <h6 i18n>Sample rates</h6>
          <p class="text-muted" i18n>Upcoming nightly rates for the selected category.</p>
          <p *ngIf="sampleLoading" i18n>Loading rates…</p>
          <p *ngIf="!sampleLoading && sampleFailed" i18n>Rate sample unavailable.</p>
          <p *ngIf="!sampleLoading && !sampleFailed && !sampleRates.length" i18n>
            No rates found for the next seven days.
          </p>
          <ng-container *ngIf="!sampleLoading && sampleRates.length">
            <p *ngIf="channelAdjusted" i18n>Channel adjustments are included.</p>
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th scope="col" i18n>Date</th>
                  <th scope="col" class="text-right" i18n>Nightly rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rate of sampleRates">
                  <td>{{ rate.start * 1000 | date : 'mediumDate' : 'UTC' }}</td>
                  <td class="text-right">{{ rate.price | number : '1.2-2' }} {{ rate.currency }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </section>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="config.rental" (click)="viewRatesCalendar()" type="button" class="btn btn-light mr-auto">
      <i class="far fa-calendar-alt"></i> <ng-container i18n>View Rates Calendar</ng-container>
    </button>
    <button (click)="close()" type="button" class="btn btn-light">
      <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
    </button>
    <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
      <i class="fal fa-arrow-up"></i> {{ config.buttonText }}
    </button>
  </div>
</form>
